import { defineComponent as _defineComponent } from 'vue'
import { isValidLength, noLineBreak, required } from '@/lib/rule';
import store from '@/store';
import { dispatchCreateUserSearchCriteria } from '@/store/main/actionsMain';
import {
  readAssertedCompanyId,
  readAssertedUserProfile,
} from '@/store/main/getters';
import { ref, watch } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { SDS_FILTER_LOCAL_STORAGE_KEY } from '@/composables/useSdsFilter';
import { UserSearchCriteria } from '@/interfaces/api/general/company';


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveMyFilterDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["input", "created"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'created', value: UserSearchCriteria): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
};

const m = defineMessages({
  modalTitle: '現在のフィルター条件に名前をつけて保存する',
  modalDescription:
    'フィルター条件を保存することで、ワンクリックで適用することができるようになります。',
  formLabel: 'フィルター条件名（必須）',
  hint: '48文字以内',
});




const localValue = ref(props.value);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

const isValidForm = ref(false);
const isLoading = ref(false);
const formRef = ref();
const name = ref('');

const closeDialog = () => {
  if (isLoading.value) {
    return;
  }

  formRef.value?.reset();
  localValue.value = false;
  emits('input', false);
};

const sanitize = (value: string) => {
  // Remove line breaks and spaces
  name.value = value.replace(/\r?\n/g, '').replace(/\s/g, '');
};

const handleSaveClick = async () => {
  formRef.value?.validate();
  if (!isValidForm.value) {
    return;
  }
  isLoading.value = true;
  try {
    const criteria = JSON.parse(
      localStorage.getItem(SDS_FILTER_LOCAL_STORAGE_KEY) || '{}'
    );
    const response = await dispatchCreateUserSearchCriteria(store, {
      userId: readAssertedUserProfile(store).uuid,
      companyId: readAssertedCompanyId(store),
      name: name.value,
      criteria,
    });
    if (!response || !response.data) {
      throw new Error('Failed to create user search criteria');
    }
    isLoading.value = false;
    closeDialog();
    emits('created', response.data);
  } catch (e) {
    isLoading.value = false;
  }
};

const handleCancelClick = () => {
  closeDialog();
};

return { __sfc: true,m, props, emits, localValue, isValidForm, isLoading, formRef, name, closeDialog, sanitize, handleSaveClick, handleCancelClick, isValidLength, noLineBreak, required, BaseFormCard, sharedMessages }
}

})